import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
  useLocation,
  matchPath,
} from "react-router-dom";
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useState } from "react";
import cogoToast from "cogo-toast";
import Header from "./components/Header";
 import CardInventorySummary from './pages/asset/CardInventorySummary'

import DashboardLayoutRoute from "./Layouts/DashboardLayout";

//AUTH
import LoginLayoutRoute from "./Layouts/LoginLayout";

import MyWebSurveyRoute from "./Layouts/MyWebSurvey";
import GenericLayoutRoute from "./Layouts/GenericLayout";
import OperationResult from "./pages/OperationResult";

import Login from "./pages/auth/Login";
import AuthCallback from "./pages/auth/AuthCallback";
import ResetPassword from "./pages/auth/ResetPassword";
import UpdatePassword from "./pages/auth/UpdatePassword";
import AccessRights from "./pages/auth/AccessRights";
import AccessDenied from "./pages/AccessDenied";

import Surveys from "./pages/Surveys/Surveys";
import SurveyCreation from "./pages/Surveys/SurveyCreation";
import SurveySubmissions from "./pages/Surveys/Submissions";
import SurveyMapViewer from "./pages/Surveys/SurveyMapViewer";
import SurveyResults from "./pages/Surveys/SurveyResults";
//                      #  >>            << #                                  //
// HMIS
import HmisDashboard from "./pages/hmis/HmisDashboard";
import AddPrescriptions from "./pages/hmis/AddPrescriptions";
import AddVisit from "./pages/hmis/AddVisit";
import ConsultationForm from "./pages/hmis/ConsultationForm";
import ConsultationRooms from "./pages/hmis/ConsultationRooms";
import LabTestRequest from "./pages/hmis/LabTestRequest";
import LabResultFrom from "./pages/hmis/LabResultFrom";
import RedeemPrescription from "./pages/hmis/RedeemPrescription"
import RedemptionSummary from "./pages/hmis/RedemptionSummary"
import RedemptionReport from "./pages/hmis/RedemptionReport"


import PatientListForRoom from "./pages/hmis/PatientListForRoom";
import PatientRegistration from "./pages/hmis/PatientRegistration";
import PrintVisit from "./pages/hmis/PrintVisit";

import Home from "./pages/Home";
import { helpers } from "./helpers";
import AppContext from "./AppContext";
import { useHistory } from "react-router-dom";

import Projects from "./pages/projects/Projects";
import CreateProjects from "./pages/projects/CreateProject";

import ViewProject from "./pages/projects/ViewProject";
import MasterListJobTracker from "./pages/projects/MasterListJobTracker";
import ProjectDetails from "./pages/projects/ProjectDetails";
import ActivityBeneficiaries from "./pages/projects/ActivityBeneficiaries";
import BeneficiaryClockings from "./pages/projects/BeneficiaryClockings";
import CloneBeneficiaries from "./pages/projects/CloneBeneficiaries";
import UpdateSRF from "./pages/projects/UpdateSRF";
import ProjectMapViewer from "./pages/projects/ProjectMapViewer";
import UploadProjectMappings from "./pages/Erp/UploadProjectMappings";
import ErpProjectMapping from "./pages/Erp/ErpProjectMapping";


import ComponentCycles from "./pages/projects/ComponentCycles";
import EbmsDashboard from "./pages/projects/EbmsDashboard";
import ProjectComponents from "./pages/projects/ProjectComponents";
import CycleDistributions from "./pages/projects/CycleDistributions";
import MissingCycleDistributions from "./pages/projects/MissingCycleDistributions";
import FailedCriterionList from "./pages/projects/FailedCriterionList";



import BeneficiaryList from "./pages/projects/BeneficiaryList";
import UpdateBeneficiaryDetails from "./pages/projects/UpdateBeneficiaryDetails";
import AttendanceList from "./pages/projects/AttendanceList";
import WashProjectsList from "./pages/projects/wash/WashProjectsList";
import WashProjectForm from "./pages/projects/wash/WashProjectForm";
import WashProjectDetails from "./pages/projects/wash/WashProjectDetails";
import WashProjectExcelUpload from "./pages/projects/wash/WashProjectExcelUpload";
import WashDashboard from "./pages/projects/wash/WashDashboard";





import HRMMenu from "./pages/hrm/HRMMenu";
import EmployeeList from "./pages/hrm/EmployeeList";
import UploadDesignations from "./pages/hrm/UploadDesignations";
import Uploademployees from "./pages/hrm/Uploademployees";
import UploadOffices from "./pages/hrm/UploadOffices";
import UploadStaffBankAccounts from "./pages/hrm/UploadStaffBankAccounts";
import Divisions from "./pages/hrm/Divisions";
import StaffFileTypes from "./pages/hrm/StaffFileTypes";
import StaffScoringCriteria from "./pages/hrm/StaffScoringCriteria";
import StaffScoring from "./pages/hrm/StaffScoring";
import StaffRatingsByPeriod from "./pages/hrm/StaffRatingsByPeriod";
import ScoringPeriods from "./pages/hrm/ScoringPeriods";
import UploadBudgetAllocations from "./pages/hrm/UploadBudgetAllocations";
import BudgetAllocationsReport from "./pages/hrm/payroll/budget_allocations/BudgetAllocationsReport";

import AssignAllowances from "./pages/hrm/payroll/AssignAllowances";
import AssignStaffTax from "./pages/hrm/payroll/AssignStaffTax";
import AssignTags from "./pages/hrm/payroll/AssignTags";

import DailyAttendanceReport from "./pages/hrm/attendance/DailyAttendanceReport";
import StaffAttendanceSummary from "./pages/hrm/attendance/StaffAttendanceSummary";
import StaffAttendanceDetails from "./pages/hrm/attendance/StaffAttendanceDetails";
import ExceptionalInAttendance from "./pages/hrm/attendance/ExceptionalInAttendance";
import StaffIDCards from "./pages/hrm/StaffIDCards";
import ContractTrackSheet from "./pages/hrm/ContractTrackSheet";
import WorkforcePlanningList from "./pages/hrm/workforce-planning/WorkforcePlanningList";
import WorkforcePlanningForm from "./pages/hrm/workforce-planning/WorkforcePlanningForm";
import WorkforcePlanningDetails from "./pages/hrm/workforce-planning/WorkforcePlanningDetails";
import WorkforcePlanningAnalysis from "./pages/hrm/workforce-planning/WorkforcePlanningAnalysis";
import RoleDepartments from "./pages/hrm/RoleDepartments";





import ListPayroll from "./pages/hrm/payroll/ListPayroll";
import ListPayrollSetup from "./pages/hrm/payroll/ListPayrollSetup";

import PayrollSelection from "./pages/hrm/payroll/PayrollSelection";

import CompletedPayroll from "./pages/hrm/payroll/CompletedPayroll";

import PayrollDetails from "./pages/hrm/payroll/PayrollDetails";
import Payslip from "./pages/hrm/payroll/Payslip";
import EmployeeProfile from "./pages/hrm/EmployeeProfile";

import PendingAdvances from "./pages/hrm/payroll/PendingAdvances";

import ProcessPayroll from "./pages/hrm/payroll/ProcessPayroll";



import CreateLeave from "./pages/hrm/leave/CreateLeave";
import ListLeaveRequests from "./pages/hrm/leave/ListLeaveRequests";
import PendingActions from "./pages/hrm/leave/PendingActions";
import ApproveLeave from "./pages/hrm/leave/ApproveLeave";
import MyLeaveRequests from "./pages/hrm/leave/MyLeaveRequests";
import StaffPayslips from "./pages/hrm/StaffPayslips";
import Dashboard from "./pages/Dashboard";
import PrintLeave from "./pages/hrm/leave/PrintLeave";
import LeaveBalances from "./pages/hrm/leave/LeaveBalances";


import CreateToil from "./pages/hrm/toil/CreateToil";
import PendingToilActions from "./pages/hrm/toil/PendingToilActions";
import ToilDetails from "./pages/hrm/toil/ToilDetails";
import MyToilRequests from "./pages/hrm/toil/MyToilRequests";
import PendingToilClaims from "./pages/hrm/toil/PendingToilClaims";
import ToilClaimDetails from "./pages/hrm/toil/ToilClaimDetails";
import CreateBudgetAllocations from "./pages/hrm/payroll/budget_allocations/CreateBudgetAllocations";
import CreateMonthlyBudgetAllocations from "./pages/hrm/payroll/budget_allocations/CreateMonthlyBudgetAllocations";
import ListMonthlyAllocations from "./pages/hrm/payroll/budget_allocations/ListMonthlyAllocations";
import CreateBudgetCodes from "./pages/hrm/payroll/budget_allocations/CreateBudgetCodes";



/* ------------------ ASSET   -------------------- */

import AssetList from "./pages/asset/AssetList";
import CategoryList from "./pages/asset/CategoryList";
import WebSurveys from "./pages/Surveys/WebSurveys";
import OngoingSurveys from "./pages/Surveys/OngoingSurveys";
import InlineWebSurveys from "./pages/Surveys/InlineWebSurveys";
import IdDetails from "./pages/hrm/IdDetails";
import { genericGet, logout_api } from "./services/Api";
import { log, isValidRedirectUrl, saveRedirectUrlIfValid, clearAuthSession, getEncryptedUserData, getEncryptedAccessToken, hasLoggedInStaffProfile, mergeUserWithTokenClaims, attachUserPhoto, isAuthenticatedSession } from "./services/Utils";
import { PERMS } from './pages/config/perms'
import ability from './pages/config/defineAbility';
import { ADMIN_ROLE } from './Constants';
import TemplateConfigurations from './pages/common/TemplateConfigurations'
import ManagePermissions from './pages/auth/ManagePermissions'
// import { PaginatedGrid} from './pages/asset/PaginatedGrid'
import ListingPage from './pages/asset/CardsListing'
//  workflow
import Workflows from "./pages/workflows/Workflows";
import ProjectWorkflows from "./pages/projects/ProjectWorkflows";
import WorkflowLevels from "./pages/workflows/WorkflowLevels";

// USER MANAGEMENT
import Users from "./pages/admin/users";
import UploadBnf from "./pages/admin/UploadBnf";
import UploadCva from "./pages/admin/UploadCva";
import AuditLogs from "./pages/admin/AuditLogs";
import SystemNotifications from "./pages/admin/SystemNotifications";
import Settings from "./pages/admin/Settings";
 import PayrollSummary from "./pages/hrm/payroll/PayrollSummary ";
 import GeneratePayslips from "./pages/hrm/payroll/GeneratePayslips";

// //testing
// import testing from "./pages/testing/testing"


// import ability from './pages/config/defineAbility';

// import { PERMS } from "./pages/auth/config/StaticPerm";


// import { getDb as db,initializeSchema } from "./services/DbHelper";


/* --------------------- HMIS Ends Here ----------------------- */

// Protected Route Component - redirects to login when unauthenticated, AccessDenied when unauthorized
const ProtectedRoute = ({ action, subject, permissionCheck, component: Component, exact, path, ...rest }) => {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(props) => {
        if (!isAuthenticatedSession()) {
          const returnPath = `${props.location.pathname}${props.location.search}${props.location.hash}`;
          saveRedirectUrlIfValid(returnPath);
          clearAuthSession();
          return <Redirect to="/login" />;
        }

        const hasPermission = permissionCheck
          ? permissionCheck()
          : action && subject
            ? ability.can(action, subject)
            : true;

        if (hasPermission) {
          return <Component {...props} />;
        }
        return <AccessDenied />;
      }}
    />
  );
};

function App() {
  const history = useHistory();
  const [is_loggedIn, setIs_loggedIn] = useState(
    getEncryptedAccessToken() ? true : false
  );
  //INITIALIZE DBSCHEMA
  // initializeSchema();
  // const ability = new Ability([
  //   {
  //     action:PERMS.READ,
  //     subject:PERMS.MANAGE_PERMS
  //   }
  // {
  //   action: 'can_view_all_employees',
  // },
  // {
  //   action: 'can_view_own_employee',
  //   conditions: { companyId: '1234' },
  // }
  // ]);

  const get_logged_in_user = () => {
    let token  = getEncryptedAccessToken();
if(token==null){
  return null;
}

    // Use encrypted user data getter
    let user = getEncryptedUserData();
    if (!user) {
      return null;
    }
    return attachUserPhoto(mergeUserWithTokenClaims(user));

    // var base64Url = token.split(".")[1];
    // var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    // var jsonPayload = decodeURIComponent(
    //   atob(base64)
    //     .split("")
    //     .map(function (c) {
    //       return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    //     })
    //     .join("")
    // );

    // let _user = JSON.parse(jsonPayload);

    // return _user;
  };

  const get_company_info = () => {
    let company_info = JSON.parse(localStorage.getItem("company_info"));
    return company_info;
  };

  const getSetting_data = () => {
    let setting = JSON.parse(localStorage.getItem("setting"));
    return setting;
  };

  const get_app_mode = () => {
    let app_mode = JSON.parse(localStorage.getItem("app_mode"));

    return app_mode;
  };

  const logout = () => {
      let allowed_routes = [
      "/error/access-denied",
      "/operation/result",
      "/",
      "/login",
      "/auth/callback",
      "/reset-password",
      "/update-password",
      "/update-password",
      "/ebms/web-survey"
    ];

    let allowed = allowed_routes.includes(location.pathname);

    // Save redirectUrl BEFORE checking if route is allowed
    const returnPath = `${location.pathname}${location.search}${location.hash}`;
    if (!allowed && saveRedirectUrlIfValid(returnPath)) {
      // captured for post-login redirect
    } else if (!allowed) {
      localStorage.removeItem("redirectUrl");
    }

    if (allowed) {
      return;
    }

    if (getEncryptedAccessToken()) {
      logout_api().catch(() => {});
    }

    clearAuthSession();
    setIs_loggedIn(false);

    history.push({
      pathname: "/login",
    });



  };

  const handleOnIdle = (event) => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      // Timer disabled on localhost
    } else {
      logout();
    }
  };

  const handleOnActive = (event) => {
    // User is active
  };

  const handleOnAction = (event) => {
    // User action detected
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 14400000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  });

  function generate_numbers(n) {
    var add = 1,
      max = 12 - add; // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.

    if (n > max) {
      return generate_numbers(max) + generate_numbers(n - max);
    }

    max = Math.pow(10, n + add);
    var min = max / 10; // Math.pow(10, n) basically
    var number = Math.floor(Math.random() * (max - min + 1)) + min;

    return ("" + number).substring(add);
  }

  const handle_api_error = (e) => {
    if (e.response) {
      let _status = e.response.status;

      if (_status == 401) {
        cogoToast.error("Session Expired!", {
          hideAfter: 7,
        });
        logout();
      } else {
        show_operation_result({ success: false, message: e.toString() });
      }
    }
  };

  const show_operation_result = (result) => {
    history.push({
      pathname: "/operation/result",
      state: result,
    });
  };
  const networkStatus = () => {
    window.addEventListener("load", () => {
      // 1st, we set the correct status when the page loads
      // navigator.onLine
      //   ? cogoToast.success(`You are online  `, {
      //     hideAfter: 5,
      //   })
      //   : cogoToast.error(`You are Offline ! `, {
      //     hideAfter: 5,
      //   });

      // now we listen for network status changes
      window.addEventListener("online", () => {
        document
          .querySelectorAll(".ct-toast-error")
          .forEach((el) => el.remove());

        cogoToast.success(`Internet Connection Restored`, {
          hideAfter: 5,
          position: "bottom-center",
        });
      });

      window.addEventListener("offline", () => {
        cogoToast.error(`Internet Connection lost (Offline) `, {
          hideAfter: 1505,
          position: "bottom-center",
        });
      });
    });
  };

  const show_loading_overlay = (text) => {
    window.bootbox.dialog({
      message: `<h3> ${text} </h3><div class="progress" style="width:100% !important">
        <div class="progress-bar progress-bar-indeterminate bg-green"></div>
      </div>`,
      centerVertical: true,
      closeButton: false,
      className: "smd",
    });
  };

  const hide_loading_overlay = () => {
    document.querySelectorAll(".bootbox").forEach((e) => e.remove());
    document.querySelectorAll(".modal-backdrop").forEach((e) => e.remove());
  };
  const get_user_ip_details = async () => {
    let ip = "";
    genericGet("https://www.google.com", {}).then((res) => {
      ip = res.data.IPv4;
      log("IP", ip);

    });
    return ip;
  };
  const GlobalStates = {
    logout,
    handle_api_error,
    get_logged_in_user,
    generate_numbers,
    getRemainingTime,

    getSetting_data,
    get_company_info,
    get_app_mode,

    setIs_loggedIn,
    show_loading_overlay,
    hide_loading_overlay,
    show_operation_result,
    get_user_ip_details,
    ability
  };

  window.h = helpers;
  const location = useLocation();

  React.useEffect(() => {
    networkStatus();
    
    // Clean up any invalid redirectUrl on app initialization
    const storedRedirectUrl = localStorage.getItem("redirectUrl");
    if (storedRedirectUrl && !isValidRedirectUrl(storedRedirectUrl)) {
      localStorage.removeItem("redirectUrl");
    }
    
    // Note: We don't check user-data size here because encrypted data can be legitimately large
    // The decryption function will handle corrupted data and clear it if needed
    
    if (location.pathname == "/login" || location.pathname == "/auth/callback") {
      return;
    }
    if (
      location.pathname.includes("ebms/web-survey") ||
      location.pathname.startsWith("/staff/") ||
      location.pathname.includes("ongoing/inline-web-survey") ||
      location.pathname.startsWith("/projects/wash/dashboard")
    ) {
      // alert("Here we are serious"); /ebms/surveys/ongoing/inline-web-survey/:id
      return true;
    } else {
      // alert("Here we are serious at ELSE"); 
    }
    const loggedInUser = get_logged_in_user();
    if (!loggedInUser) {
      logout();
      return;
    }

    if (get_logged_in_user().user_id == 1) {
      return true;
    }


    if (location.pathname === "/error/access-denied") {
      return;
    }

    // Legacy route_name checks removed to avoid conflicting authorization paths.
    // Access control is enforced by ProtectedRoute + CASL permission checks.
  }, [location]);

  const user = get_logged_in_user();

  return (
    <AppContext.Provider value={GlobalStates}>
      <Switch>
     
        <LoginLayoutRoute path="/login" component={Login} />
        <LoginLayoutRoute path="/auth/callback" component={AuthCallback} />
         {/* <LoginLayoutRoute path="/reset-password" component={ResetPassword} /> */}
        {/* <LoginLayoutRoute path="/update-password" component={UpdatePassword} /> */}
        <MyWebSurveyRoute path="/ebms/web-survey/:id" component={WebSurveys} />
        

        {/* Public staff ID card details route */}
        <GenericLayoutRoute path="/staff/:id" component={IdDetails} />
        <GenericLayoutRoute
          path="/ebms/surveys/ongoing/inline-web-survey/:id"
          component={InlineWebSurveys}
        />
        {/* Public WASH dashboard (passcode only; no login) */}
        <GenericLayoutRoute
          exact
          path="/projects/wash/dashboard"
          component={WashDashboard}
        />
        <DashboardLayoutRoute>
          <div className="page-wrapper">
            <Header />

            <div className="container-xlx inner-page">
              <br />
              <Route exact path="/">
                {is_loggedIn ? (
                  <Redirect to="/dashboard" />
                ) : (
                  <Redirect to="/login" />
                )}
              </Route>
              {/* BY MOSES */} 
              {/* <Route exact path="/dashboard" component={Home} /> */}
              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/error/access-denied" component={AccessDenied} />

              {/* SURVEYS */}
              <ProtectedRoute exact path="/ebms/surveys/list" component={Surveys} action={PERMS.READ} subject={PERMS.SURVEYS} />
              {/* <Route exact  path="/ebms/surveys/web-survey/:id" component={WebSurveys} /> */}
              <ProtectedRoute exact path="/ebms/surveys/create" component={SurveyCreation} action={PERMS.CREATE} subject={PERMS.CREATE_SURVEYS} />
              <ProtectedRoute 
                exact 
                path="/ebms/surveys/ongoing" 
                component={OngoingSurveys} 
                permissionCheck={() => ability.can(PERMS.READ, PERMS.SURVEYS) || ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) || ability.can(PERMS.READ, PERMS.LIST_SURVEYS)}
              />
              {/* <Route exact path="/ebms/surveys/ongoing/inline-web-survey/:id" component={InlineWebSurveys} /> */}

              <ProtectedRoute
                path="/ebms/surveys/submissions"
                component={SurveySubmissions}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.SURVEYS) || ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) || ability.can(PERMS.READ, PERMS.LIST_SURVEYS)}
              />
              <ProtectedRoute
                path="/ebms/surveys/submissions-map"
                component={SurveyMapViewer}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.SURVEYS) || ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) || ability.can(PERMS.READ, PERMS.LIST_SURVEYS)}
              />
              <ProtectedRoute
                path="/ebms/surveys/results"
                component={SurveyResults}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.SURVEYS) || ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) || ability.can(PERMS.READ, PERMS.LIST_SURVEYS)}
              />

              {/* // HMIS ROUTES */}
              <ProtectedRoute exact path="/hmis/dashboard" component={HmisDashboard} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/add-prescriptions" component={AddPrescriptions} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/add-visit" component={AddVisit} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/consultation-form" component={ConsultationForm} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/consultation-rooms" component={ConsultationRooms} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/request-lab-test" component={LabTestRequest} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/lab-result-form" component={LabResultFrom} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/patient-list-for-room" component={PatientListForRoom} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/patient-registration" component={PatientRegistration} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/print-visit" component={PrintVisit} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/redeem-prescriptions" component={RedeemPrescription} action={PERMS.READ} subject={PERMS.HMIS} />
              <ProtectedRoute exact path="/hmis/redemption-summary" component={RedemptionSummary} action={PERMS.READ} subject={PERMS.CAN_VIEW_REDEPTION_REPORT} />
              <ProtectedRoute exact path="/hmis/redemption-report" component={RedemptionReport} action={PERMS.CREATE} subject={PERMS.CAN_VIEW_REDEPTION_REPORT} />
              {/* ASSET */}
              <ProtectedRoute exact path="/asset/asset-list" component={AssetList} permissionCheck={() => ability.can(PERMS.READ, PERMS.ASSET) && ability.can(PERMS.READ, PERMS.LIST_ASSETS)} />
              <ProtectedRoute exact path="/asset/category-list" component={CategoryList} permissionCheck={() => ability.can(PERMS.READ, PERMS.ASSET) && ability.can(PERMS.READ, PERMS.LIST_ASSET_CATEGORIES)} />
              <ProtectedRoute exact path="/cards/list" component={ListingPage} permissionCheck={() => ability.can(PERMS.READ, PERMS.ASSET) && ability.can(PERMS.READ, PERMS.LIST_ASSETS)} />
              {/* <Route exact path="/asset/asset-list" component={AssetList} /> */}
              <Route exact path="/asset/cards-summary" component={CardInventorySummary} />

              {/* --------------------- 
              
              Ends Here ----------------------- */}
              {/* <Route component={NotFound} /> */}
              
              {/* PROJECTS */}
              <ProtectedRoute exact path="/projects/list" component={Projects} action={PERMS.READ} subject={PERMS.LIST_PROJECTS} />
              <ProtectedRoute exact path="/projects/create" component={CreateProjects} action={PERMS.CREATE} subject={PERMS.CREATE_PROJECT} />
              <ProtectedRoute 
                exact 
                path="/projects/view" 
                component={ViewProject} 
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/masterlist-job-tracker/:queueJobId"
                component={MasterListJobTracker}
                action={PERMS.READ}
                subject={PERMS.GENERATE_MASTER_LIST}
              />
              <ProtectedRoute
                exact
                path="/projects/details/:id"
                component={ProjectDetails}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/activity-beneficiaries/:component_id"
                component={ActivityBeneficiaries}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/beneficiary-clockings/:cycle_id"
                component={BeneficiaryClockings}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/clone-beneficiaries"
                component={CloneBeneficiaries}
                permissionCheck={() => ability.can(PERMS.CREATE, PERMS.CAN_CLONE_BENEFICIARIES)}
              />
              <ProtectedRoute
                exact
                path="/projects/upload-project-mappings"
                component={UploadProjectMappings}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_UPLOAD_PROJECT_MAPPINGS)}
              />
              <ProtectedRoute
                exact
                path="/projects/erp-project-mapping"
                component={ErpProjectMapping}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_VIEW_PROJECT_MAPPING_LISTING)}
              />
              <ProtectedRoute 
                exact 
                path="/projects/MapViewer" 
                component={ProjectMapViewer} 
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/components"
                component={ProjectComponents}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/cycle-distributions"
                component={CycleDistributions}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/missing-cycle-distributions"
                component={MissingCycleDistributions}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/failed-criterion"
                component={FailedCriterionList}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute 
                exact 
                path="/projects/cycles" 
                component={ComponentCycles} 
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/list-cycles-attendance"
                component={AttendanceList}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/wash"
                component={WashProjectsList}
                action={PERMS.READ}
                subject={PERMS.LIST_WASH_PROJECTS}
              />
              <ProtectedRoute
                exact
                path="/projects/wash/create"
                component={WashProjectForm}
                permissionCheck={() =>
                  ability.can(PERMS.CREATE, PERMS.CREATE_WASH_PROJECT) ||
                  ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS)
                }
              />
              <ProtectedRoute
                exact
                path="/projects/wash/upload"
                component={WashProjectExcelUpload}
                permissionCheck={() =>
                  ability.can(PERMS.CREATE, PERMS.CREATE_WASH_PROJECT) ||
                  ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS)
                }
              />
              <ProtectedRoute
                exact
                path="/projects/wash/edit/:id"
                component={WashProjectForm}
                permissionCheck={() =>
                  ability.can(PERMS.UPDATE, PERMS.UPDATE_WASH_PROJECT) ||
                  ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS)
                }
              />
              <ProtectedRoute
                exact
                path="/projects/wash/details/:id"
                component={WashProjectDetails}
                action={PERMS.READ}
                subject={PERMS.LIST_WASH_PROJECTS}
              />
              <ProtectedRoute
                exact
                path="/projects/beneficiary-list"
                component={BeneficiaryList}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/update-beneficiary"
                component={UpdateBeneficiaryDetails}
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              <ProtectedRoute
                exact
                path="/projects/update-srf/:project_id"
                component={UpdateSRF}
                permissionCheck={() => ability.can(PERMS.UPDATE, PERMS.CAN_UPDATE_SRF_FORM)}
              />
              <ProtectedRoute 
                exact 
                path="/ebms/dashboard" 
                component={EbmsDashboard} 
                permissionCheck={() => ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)}
              />
              {/* HRM */}
              <ProtectedRoute exact path="/hrm" component={HRMMenu} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM)} />
              <ProtectedRoute exact path="/hrm/sectors" component={Divisions} permissionCheck={() => {
                try {
                  const user = getEncryptedUserData();
                  if (!user) return false;
                  const userRole = user.role || user.role_id || user.user_id;
                  return parseInt(userRole) === ADMIN_ROLE || userRole === ADMIN_ROLE;
                } catch (e) {
                  return false;
                }
              }} />
              <ProtectedRoute exact path="/hrm/staff-file-types" component={StaffFileTypes} permissionCheck={() => {
                try {
                  const user = getEncryptedUserData();
                  if (!user) return false;
                  const userRole = user.role || user.role_id || user.user_id;
                  return parseInt(userRole) === ADMIN_ROLE || userRole === ADMIN_ROLE;
                } catch (e) {
                  return false;
                }
              }} />
              <ProtectedRoute exact path="/hrm/staff-scoring-criteria" component={StaffScoringCriteria} permissionCheck={() => {
                try {
                  const user = getEncryptedUserData();
                  if (!user) return false;
                  const userRole = user.role || user.role_id || user.user_id;
                  return parseInt(userRole) === ADMIN_ROLE || userRole === ADMIN_ROLE;
                } catch (e) {
                  return false;
                }
              }} />
              <ProtectedRoute exact path="/hrm/staff-scoring" component={StaffScoring} permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_ACCESS_STAFF_SCORING)} />
              <ProtectedRoute exact path="/hrm/staff-ratings-by-period" component={StaffRatingsByPeriod} permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_ACCESS_STAFF_SCORING_RESULTS)} />
              <ProtectedRoute exact path="/hrm/scoring-periods" component={ScoringPeriods} permissionCheck={() => {
                try {
                  const user = getEncryptedUserData();
                  if (!user) return false;
                  const userRole = user.role || user.role_id || user.user_id;
                  return parseInt(userRole) === ADMIN_ROLE || userRole === ADMIN_ROLE;
                } catch (e) {
                  return false;
                }
              }} />
              <ProtectedRoute exact path="/hrm/employee-list" component={EmployeeList} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.LIST_EMPLOYEES)} />
              <ProtectedRoute exact path="/hrm/upload-designations" component={UploadDesignations} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.UPLOAD_DESIGNATIONS)} />
              <ProtectedRoute exact path="/hrm/upload-employees" component={Uploademployees} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.UPLOAD_EMPLOYEES)} />
              <ProtectedRoute exact path="/hrm/upload-offices" component={UploadOffices} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.UPLOAD_OFFICES)} />
              <ProtectedRoute exact path="/hrm/upload-bank-accounts" component={UploadStaffBankAccounts} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.UPLOAD_BANK_ACCOUNTS)} />
              <ProtectedRoute exact path="/hrm/upload-budget-allocations" component={UploadBudgetAllocations} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.UPLOAD_BUDGET_ALLOCATIONS)} />
              <ProtectedRoute exact path="/hrm/budget-allocations-report" component={BudgetAllocationsReport} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_BUDGET_ALLOCATIONS_REPORT)} />
              <ProtectedRoute exact path="/hrm/payroll-summary/:id" component={PayrollSummary} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_PAYROLL_SUMMARY)} />
              <ProtectedRoute exact path="/hrm/payroll-summary/" component={PayrollSummary} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_PAYROLL_SUMMARY)} />
              <ProtectedRoute exact path="/hrm/generate-payslips" component={GeneratePayslips} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_DOWNLOAD_PAYSLIPS)} />
              <ProtectedRoute exact path="/hrm/list-payroll-setup" component={ListPayrollSetup} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/list-payroll" component={ListPayroll} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/payroll-selection" component={PayrollSelection} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.UPDATE, PERMS.CAN_UPDATE_PAYROLL)} />
              <ProtectedRoute exact path="/hrm/completed-payroll" component={CompletedPayroll} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_COMPLETED_PAYROLL)} />
              <ProtectedRoute exact path="/hrm/payroll-details" component={PayrollDetails} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/Payslip" component={Payslip} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/payroll/pending-advances" component={PendingAdvances} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_PENDING_ADVANCE_REQUESTS)} />
              <ProtectedRoute exact path="/hrm/payroll/process-payroll" component={ProcessPayroll} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.CAN_PROCESS_PAYROLL)} />
              <ProtectedRoute exact path="/hrm/payroll/create-allocations" component={CreateBudgetAllocations} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.CREATE_BUDGET_ALLOCATIONS)} />
              <ProtectedRoute exact path="/hrm/payroll/create-monthly-allocations" component={CreateMonthlyBudgetAllocations} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/payroll/monthly-allocations" component={ListMonthlyAllocations} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/payroll/create-budget-codes" component={CreateBudgetCodes} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.CREATE, PERMS.CAN_CREATE_BUDGET_CODES)} />
              <ProtectedRoute exact path="/hrm/payroll/assign-allowances" component={AssignAllowances} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.UPDATE, PERMS.CAN_ASSIGN_STAFF_ALLOWANCE)} />
              <ProtectedRoute exact path="/hrm/payroll/assign-staff-tax" component={AssignStaffTax} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.UPDATE, PERMS.CAN_ASSIGN_STAFF_TAX)} />
              <ProtectedRoute exact path="/hrm/payroll/assign-tags" component={AssignTags} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.UPDATE, PERMS.CAN_ASSIGN_STAFF_TAGS)} />




              <ProtectedRoute exact path="/hrm/employee-profile" component={EmployeeProfile} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/leave/create" component={CreateLeave} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/leave/list-requests" component={ListLeaveRequests} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.LEAVE_REQUEST_REPORT)} />
              <ProtectedRoute path="/hrm/leave/pending-actions" component={PendingActions} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute path="/hrm/leave/approve-leave/:id" component={ApproveLeave} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/leave/my-leave-requests" component={MyLeaveRequests} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/payslips" component={StaffPayslips} permissionCheck={() => hasLoggedInStaffProfile(get_logged_in_user())} />
              <ProtectedRoute exact path="/hrm/leave/print" component={PrintLeave} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/leave/balances" component={LeaveBalances} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_LEAVE_BALANCE_REPORT)} />
              <ProtectedRoute exact path="/hrm/toil/create" component={CreateToil} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/toil/pending-toil-actions" component={PendingToilActions} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute path="/hrm/toil/details/:id" component={ToilDetails} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/toil/details" component={ToilDetails} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/toil/my-requests" component={MyToilRequests} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/toil/pending-toil-claims" component={PendingToilClaims} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/toil/claim-details" component={ToilClaimDetails} action={PERMS.READ} subject={PERMS.HRM} />
              {/* // STAFF ATTENDANCE */}
              <ProtectedRoute exact path="/hrm/attendance/daily-attendance" component={DailyAttendanceReport} action={PERMS.READ} subject={PERMS.HRM} />
              <ProtectedRoute exact path="/hrm/attendance/attendance-summary" component={StaffAttendanceSummary} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_STAFF_ATTENDANCE)} />
              <ProtectedRoute exact path="/hrm/attendance/attendance-details" component={StaffAttendanceDetails} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_STAFF_ATTENDANCE)} />
              <ProtectedRoute exact path="/hrm/exceptional-inattendance" component={ExceptionalInAttendance} permissionCheck={() => ability.can(PERMS.READ, PERMS.HRM) && ability.can(PERMS.READ, PERMS.CAN_VIEW_STAFF_ATTENDANCE)} />
              <ProtectedRoute exact path="/hrm/staff-id-cards" component={StaffIDCards} permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_VIEW_STAFF_ID_CARD_DETAILS)} />
              <ProtectedRoute exact path="/hrm/contract-tracksheet" component={ContractTrackSheet} permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_ACCESS_CONTRACT_TRACKSHEET)} />
              <ProtectedRoute exact path="/hrm/workforce-planning" component={WorkforcePlanningList} permissionCheck={() => ability.can(PERMS.CREATE, PERMS.CAN_CREATE_WORKFORCE_PLANNING)} />
              <ProtectedRoute exact path="/hrm/workforce-planning/create" component={WorkforcePlanningForm} permissionCheck={() => ability.can(PERMS.CREATE, PERMS.CAN_CREATE_WORKFORCE_PLANNING)} />
              <ProtectedRoute exact path="/hrm/workforce-planning/edit/:id" component={WorkforcePlanningForm} permissionCheck={() => ability.can(PERMS.CREATE, PERMS.CAN_CREATE_WORKFORCE_PLANNING)} />
              <ProtectedRoute exact path="/hrm/workforce-planning/details/:id" component={WorkforcePlanningDetails} permissionCheck={() => ability.can(PERMS.CREATE, PERMS.CAN_CREATE_WORKFORCE_PLANNING)} />
              <ProtectedRoute exact path="/hrm/workforce-planning/analysis" component={WorkforcePlanningAnalysis} permissionCheck={() => ability.can(PERMS.READ, PERMS.CAN_VIEW_WORKFORCE_PLANNING_ANALYSIS)} />
              <ProtectedRoute exact path="/hrm/role-departments" component={RoleDepartments} permissionCheck={() => ability.can(PERMS.UPDATE, PERMS.MANAGE_STAFF_ROLES)} />

                {/* //AUTHENTICATE RIGHTS */}
              <ProtectedRoute exact path="/ebms/access-rights" component={AccessRights} permissionCheck={() => (ability.can(PERMS.UPDATE, PERMS.MANAGE_ACCESS) && user?.role=="999")} />
              <ProtectedRoute exact path="/ebms/template-configurations" component={TemplateConfigurations} action={PERMS.UPDATE} subject={PERMS.UPDATE_TEMPLATES} />
              <ProtectedRoute exact path="/ebms/manage-permissions" component={ManagePermissions} permissionCheck={() => (ability.can(PERMS.UPDATE, PERMS.MANAGE_PERMISSIONS) && user?.role=="999")} />
              {/* // Workflows */}
              <ProtectedRoute exact path="/workflows/" component={Workflows} action={PERMS.CREATE} subject={PERMS.MANAGE_WORKFLOWS} />
              <ProtectedRoute exact path="/workflows/levels" component={WorkflowLevels} action={PERMS.CREATE} subject={PERMS.MANAGE_WORKFLOWS} />
              <Route exact path="/project/workflows/" component={ProjectWorkflows} />
              <Route exact path="/operation/result/" component={OperationResult} />
              {/* -------------------- ADMIN starts here --------------------*/}
              <ProtectedRoute exact path="/users/list" component={Users} action={PERMS.READ} subject={PERMS.MANAGE_USERS} />
              <ProtectedRoute
                exact
                path="/admin/audit-logs"
                component={AuditLogs}
                action={PERMS.READ}
                subject={PERMS.MANAGE_USERS}
              />
              <ProtectedRoute
                exact
                path="/admin/system-notifications"
                component={SystemNotifications}
                action={PERMS.READ}
                subject={PERMS.MANAGE_USERS}
              />
              <ProtectedRoute
                exact
                path="/admin/settings"
                component={Settings}
                action={PERMS.READ}
                subject={PERMS.MANAGE_USERS}
              />
              <ProtectedRoute
                exact
                path="/admin/upload-bnf"
                component={UploadBnf}
                action={PERMS.CREATE}
                subject={PERMS.CAN_UPLOAD_BENEFICIARY_RECORDS}
              />
              <ProtectedRoute
                exact
                path="/admin/upload-cva"
                component={UploadCva}
                action={PERMS.CREATE}
                subject={PERMS.CAN_UPLOAD_CVA_RECORDS}
              />



            </div>
          </div>
        </DashboardLayoutRoute>
      </Switch>
    </AppContext.Provider>
  );
}

export default App;
